module.exports = __webpack_public_path__ + "static/sport/img-swiper5.0f72bdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-swiper5.png
// module id = 0E1x
// module chunks = 0